import { createTranslationObject } from '../helper';
import { Locale } from 'chaika-enums';
export const geTranslations = createTranslationObject(Locale.Ge);
